import { render, staticRenderFns } from "./bbs0router.vue?vue&type=template&id=6065ca5f&scoped=true"
import script from "./bbs0router.vue?vue&type=script&lang=js"
export * from "./bbs0router.vue?vue&type=script&lang=js"
import style0 from "./bbs0router.vue?vue&type=style&index=0&id=6065ca5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065ca5f",
  null
  
)

export default component.exports